// PrivateRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = ({ isLoggedIn }) =>
  isLoggedIn ? <Outlet /> : <Navigate to="/" />;

export default PrivateRoute;
